import { useState } from "react";
import AppContext from "./AppContext";

function AppState(props){
    const [beaconData, setBeaconData] = useState({})
    const [location , setLocation] = useState([])
    const [gateway , setGateway] = useState([])
    const [category , setCategory] = useState([])
    const [asset , setAsset] = useState([])
    const [socketData , setSocketData] = useState([])
    const [notification , setNotification] = useState([])
    const [userRole, setUserRole] = useState({})



    return (
        <AppContext.Provider value={{ beaconData ,setUserRole, setBeaconData, category, setCategory, location, setLocation, setGateway, gateway, setAsset, asset, check: 'passed', setSocketData, socketData,userRole, setNotification, notification}}>
             {props.children}
        </AppContext.Provider>
    )
}

export default AppState